import type { CSSProperties } from 'react';
import { ICON, ICON_COLOR, ICON_SIZE, type IconColorValue, type IconSizeValue } from '../../constants/IconConstants';
import IconComponent from '../Icon/Icon';
import styles from './styles.module.scss';

interface SpinnerProps {
  size?: IconSizeValue;
  color?: IconColorValue;
  style?: CSSProperties;
}

const Spinner = (props: SpinnerProps) => {
  const { size = ICON_SIZE.X_SMALL, color = ICON_COLOR.DARK_GREY, style = {} } = props;
  return (
    <span style={{ ...style }} className={styles.loader}>
      <IconComponent Icon={ICON.CIRCLE_PROGRESS} size={size} color={color} />
    </span>
  );
};

export default Spinner;
